import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getMapValue',
})
export class GetMapValuePipe implements PipeTransform {
  transform(map: Map<any, any>, key: any): any {
    return map?.has(key) ? map.get(key) : null;
  }
}
